import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import ContactUs from "./pages/ContactUs";
import PersonalLoan from "./pages/loans/PersonalLoan"; // ✅ Added PersonalLoan page
import VehicleLoan from "./pages/loans/VehicleLoan";
import BusinessLoan from "./pages/loans/BusinessLoan";
import HomeLoan from "./pages/loans/HomeLoan";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import "./style.css"; // ✅ Ensure global styles are applied
import TermsConditions from "./pages/useful-links/TermsConditions";
import PrivacyPolicy from "./pages/useful-links/PrivacyPolicy";
import ConsentPolicy from "./pages/useful-links/ConsentPolicy";
import Career from "./pages/useful-links/Career";
import ApplyNow from "./pages/ApplyNow";
import CompanyList from "./pages/company-category/CompanyList";
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import CreateAccount from "./pages/Auth/CreateAccount";
import SuperDash from "./pages/Dashboard/superdash";
import TelecallingDashboard from "./pages/Dashboard/dashboard";
import AddUser from "./users/addnew";
import LoanTestPage from "./Eligibility/eligibility";
import UploadDocument from "./users/upload";
import UserList from "./users/userslist";
import UserProfile from "./users/userprofile";
import NewLeadForm from "./pages/crm/NewLeads";
import UploadDocuments from "./pages/crm/UploadDocuments";
import TelecallingWorkingPage from "./pages/crm/Telecalling/telecalling2";
import PendingLoanInterested from "./pages/crm/PendingPipeLine/PendingLoanInterested";
import MyLeads from "./pages/crm/MyLeads";
import ViewLead from "./pages/crm/ViewLead";
import ValidationLeads from "./pages/crm/ValidationLeads";
import NewInfluencer from "./pages/Marketing/NewInfluencer";
import PL from "./pages/crm/ProcessFlow/PL";
import BL from "./pages/crm/ProcessFlow/BL";
import HL from "./pages/crm/ProcessFlow/HL";
import AL from "./pages/crm/ProcessFlow/AL";
import LAP from "./pages/crm/ProcessFlow/LAP";
import EligibilityResults from "./Eligibility/EligibilityResults";
import EligibilityLeads from "./pages/crm/EligibilityLeads/EligibilityLeads";
import AppPrivacyPolicy from "./pages/useful-links/CoreDialerPrivacyPolicy";

const App = () => {
  return (
    <Router>
      <Navbar />
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/coredialerprivacypolicy" element={<AppPrivacyPolicy />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/personal-loan" element={<PersonalLoan />} />
          <Route path="/vehicle-loan" element={<VehicleLoan />} />
          <Route path="/business-loan" element={<BusinessLoan />} />
          <Route path="/home-loan" element={<HomeLoan />} />
           <Route path="/Apply-Now" element={<ApplyNow />} />
          <Route path="/terms" element={<TermsConditions />} /> {/* ✅ Added PersonalLoan route */}
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/company-list" element={<CompanyList />} />
          <Route path="/dashboard" element={<TelecallingDashboard />} />
          <Route path="/telecalling" element={<TelecallingWorkingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/add-user" element={<AddUser />} />
          <Route path="/users-list" element={<UserList />} />
          <Route path="/userprofile" element={<UserProfile />} />
          <Route path="/create-account" element={<CreateAccount />} />
          <Route path="/Super-Dash" element={<SuperDash />} />
          <Route path="/newleads" element={<NewLeadForm />} />
          <Route path="/upload-docs" element={<UploadDocuments />} />
          <Route path="/apply/:token" element={<UploadDocument />} />
          <Route path="/myleads" element={<MyLeads />} />
          <Route path="/view-lead/:id" element={<ViewLead />} />
          <Route path="/validatelead" element={<ValidationLeads />} />
          <Route path="/consent-policy" element={<ConsentPolicy />} />
          <Route path="/careers" element={<Career />} />
          <Route path="/eligibility" element={<LoanTestPage />} />
          <Route path="/newinfluencer" element={<NewInfluencer />} />
          <Route path="/newinfluencer" element={<NewInfluencer />} />
          <Route path="/pending-loan-interested" element={<PendingLoanInterested />} />
          <Route path="/process-flow/pl/:randomId" element={<PL />} />
          <Route path="/process-flow/bl/:randomId" element={<BL />} />
          <Route path="/process-flow/al/:randomId" element={<AL />} />
          <Route path="/process-flow/hl/:randomId" element={<HL />} />
          <Route path="/process-flow/lap/:randomId" element={<LAP />} />
          <Route path="/results" element={<EligibilityResults />} />
          <Route path="/eligibility-leads" element={<EligibilityLeads />} />
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default App;